import { useMemo } from 'react';

import { resolveNavigation, withNavBadges } from '@/utils/access';
import { toNavBadges } from '@/utils/navBadges';
import { useCounters } from '@/hooks/counters';
import { useLive } from '@/hooks/live';

import type { TNavSection } from 'constants/navigation';

import { useAccess } from './useAccess';

const useNavigation = (): TNavSection[] => {
  const { persona } = useAccess();
  const { totalUnread } = useLive();
  const { data: counters } = useCounters();

  return useMemo(
    () => withNavBadges(resolveNavigation(persona), toNavBadges(counters, totalUnread)),
    [persona, counters, totalUnread],
  );
};

export {
  useNavigation,
};
